import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from './toast.service';
import { ToastType } from '../models/types/toast.enum';
import { Router } from '@angular/router';
import { ApiErrorMessages } from '../config/error-messages.config';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector, private toastService: ToastService) {}

  handleError(error: HttpErrorResponse): void {
    const router = this.injector.get(Router); // Get router instance

    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error, router);
    } else {
      this.toastService.show(error, ToastType.Error);
    }
  }

  handleHttpError(error: HttpErrorResponse, router: Router) {
    const formatted = this.formatErrors(error.error?.errors);
    if (formatted) {
      this.handleApiError(formatted);
      return;
    }

    switch (error.status) {
      case 400:
        this.toastService.show(`${'Bad Request. Please check your input. '}`, ToastType.Error);
        break;
      case 401:
        this.toastService.show(`${'Unauthorized! Redirecting to login...  '}`, ToastType.Error);
        router.navigate(['/login']);
        break;
      case 403:
        this.toastService.show(`${'Forbidden! You do not have permission. '}`, ToastType.Error);
        break;
      case 404:
        this.toastService.show(`${'Resource not found. '}`, ToastType.Error);
        break;
      case 500:
        this.toastService.show(`${'Server error. Please try again later. '}`, ToastType.Error);
        break;
      default:
        this.toastService.show(`${'Something went wrong. Please try again. '}`, ToastType.Error);
    }
  }

  formatErrors(errors: string[] | undefined | null): string {
    if (!errors || errors.length === 0) {
      return '';
    }
    return errors.join(' | ');
  }

  handleApiError(errorMessages: string) {
    const userFriendlyMessage = ApiErrorMessages[errorMessages];

    if (userFriendlyMessage) {
      this.toastService.show(userFriendlyMessage, ToastType.Error);
    } else {
      this.toastService.show('Something went wrong. Please try again.', ToastType.Error);
    }
  }
}
